import React, { useCallback } from "react";
import { useTranslation } from "next-i18next";
import { Search } from "../../assets";
import { debounce } from "../../utils/helpers";

export default function RecipeSearchBar({
	setSearchTerm
}) {
	const setInput = debounce((value) => {
		setSearchTerm(value);
	}, 800);
	const debouceRequest = useCallback((value) => setInput(value), [setInput]);

	const { t } = useTranslation();



	const handleChange = (e) => {
		debouceRequest(e.target.value);
	};

	return (
		<div className="search_container_blog">
			<div className="search_bar_container_blog">
				<Search />
				<input
					placeholder={t("search.placeholder")}
					type="search"
					onChange={handleChange}
				></input>
			</div>
		</div>
	);
}
